import { BaseDestinationItem } from '@/features/destinations/commons';
import { CustomConnectorDto } from '@/models/connectors';
import { FC, PropsWithChildren } from 'react';

type CustomConnectorDestinationItemProps = {
  connector: CustomConnectorDto;
} & PropsWithChildren;

export const CustomConnectorDestinationItem: FC<CustomConnectorDestinationItemProps> = ({ connector, children }) => {
  const connectorWithIcon = {
    ...connector,
    icon: `data:image/png;base64,${connector.authConfiguration.configurations[0].elements.auth.config['image']}` || '/assets/icons/default-connector.svg',
  };

  return (
    <BaseDestinationItem connector={connectorWithIcon}>
      {children}
    </BaseDestinationItem>
  );
};
